import store from '@/store';

class BillingService {
  redirectToCheckout(transactionId: string, options?: { app?: string }) {
    const company = store.state.company;
    let baseUrl;
    if (company?.domain) {
      const billingHostname = process.env.VUE_APP_BILLING_HOSTNAME.trim();
      baseUrl = `https://${billingHostname}`;
    } else {
      baseUrl = `http://localhost:${process.env.VUE_APP_PORT}`;
    }

    // The checkout page runs on a different host — the app context must travel
    // in the URL (sessionStorage does not cross origins).
    const appSuffix = options?.app ? `&app=${encodeURIComponent(options.app)}` : '';
    window.location.href = `${baseUrl}/#/checkout?transactionId=${transactionId}${appSuffix}`;
  }
}

const billingService = new BillingService();
export default billingService;
